// extracted by mini-css-extract-plugin
module.exports = {"paragraph":"compose-module--paragraph--81abec","showMoreLink":"ShowMoreLink-module--showMoreLink--73abd5 compose-module--paragraph--81abec"};